import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/global/atoms'
import { Switch as SwitchDS } from '@jisr-hr/design-system'

const Switch = ({ input, designSystem, onChange, active, ...rest }) => {
  if (designSystem) {
    return (
      <SwitchDS
        {...rest}
        {...input}
        active={input?.checked || active || input?.value}
        onChange={(e) => {
          if (onChange) onChange(e)
          input.onChange(e)
        }}
      />
    )
  }
  return (
    <div>
      <Input.Switch
        {...rest}
        active={input?.value}
        onChange={(v) => input?.onChange(v)}
        error={rest.meta?.touched && rest.meta?.error && rest.meta.error}
      />
    </div>
  )
}

Switch.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  designSystem: PropTypes.bool,
  active: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Switch
